import { t } from '../../../strings/i18n';
import { length, required } from '../../../xform';
const cvv2Config = () => [
    'cvv2',
    undefined,
    'ENABLED',
    [required(t('errors.cvvRequired')), length(t('errors.cvvInvalid'), 3)]
];
export default cvv2Config;
